module.exports = __webpack_public_path__ + "img/camera.3f2c753c.png";